export default "__VITE_ASSET__Dqk$2GRM__"